module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/777b12b55dd69be2a1707d31774c71d1.gif";